/* unplugin-vue-components disabled */import script from "./RichTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextField.vue?vue&type=script&setup=true&lang=js"

import "./RichTextField.vue?vue&type=style&index=0&id=048e534a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048e534a"]])

export default __exports__